var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fragment", [
    _c("div", { staticClass: "login-page" }, [
      _c("div", { staticClass: "form" }, [
        _c(
          "form",
          {
            staticClass: "login-form",
            on: {
              submit: function($event) {
                $event.preventDefault()
              }
            }
          },
          [
            _c("dl", { staticClass: "notice_msg" }, [
              _c("dt", [
                _c("img", {
                  attrs: {
                    src: "/static/images/logo.png",
                    alt: "Service Knowledge Portal"
                  }
                })
              ]),
              _vm._v(" "),
              _c("dd", [
                _vm._v("\n                        Request for "),
                _c("span", [_vm._v("Authorization")])
              ])
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "message" }, [_vm._v("User Name")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.userName,
                  expression: "userName"
                }
              ],
              attrs: { type: "text", name: "userName", readonly: "" },
              domProps: { value: _vm.userName },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.userName = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c("p", { staticClass: "message" }, [_vm._v("Level")]),
            _vm._v(" "),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.deptLevelCd,
                    expression: "deptLevelCd"
                  }
                ],
                attrs: { id: "deptLevelCd", name: "deptLevelCd" },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.deptLevelCd = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              [
                !_vm.loginSystem.length
                  ? _c("option", { attrs: { disabled: "", value: "" } }, [
                      _vm._v("Select")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.loginSystem.length &&
                (_vm.loginSystem === _vm.getLoginSysApprovalGSPN ||
                  _vm.loginSystem === _vm.getLoginSysSupport)
                  ? _c("option", { attrs: { value: "1" } }, [_vm._v("ASC/CC")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.loginSystem.length &&
                (_vm.loginSystem === _vm.getLoginSysSCMS ||
                  _vm.loginSystem === _vm.getLoginSysApprovalCS)
                  ? _c("option", { attrs: { value: "2" } }, [
                      _vm._v("Subsidiary")
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.loginSystem.length && _vm.deptLevelCd === 3
                  ? _c("option", { attrs: { value: "3" } }, [_vm._v("RHQ")])
                  : _vm._e(),
                _vm._v(" "),
                _vm.loginSystem.length && _vm.deptLevelCd === 4
                  ? _c("option", { attrs: { value: "4" } }, [_vm._v("GBM")])
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _vm.deptLevelCd > 3
              ? [
                  _c("p", { staticClass: "message" }, [_vm._v("GBM")]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.gbmCd,
                          expression: "gbmCd"
                        }
                      ],
                      attrs: { id: "gbmCd", name: "gbmCd" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.gbmCd = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    [
                      _c("option", { attrs: { disabled: "", value: "" } }, [
                        _vm._v("Select")
                      ])
                    ]
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.deptLevelCd < 4
              ? [
                  _c("p", { staticClass: "message" }, [_vm._v("RHQ")]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.rhqCd,
                          expression: "rhqCd"
                        }
                      ],
                      attrs: { id: "rhqCd", name: "rhqCd" },
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.rhqCd = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          function($event) {
                            return _vm.changeRhqCd($event)
                          }
                        ]
                      }
                    },
                    [
                      _vm.rhqCd !== ""
                        ? _c("option", { domProps: { value: _vm.rhqCd } }, [
                            _vm._v(_vm._s(_vm.rhqNm))
                          ])
                        : _c("option", { attrs: { disabled: "", value: "" } }, [
                            _vm._v("Select")
                          ])
                    ]
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.deptLevelCd < 3
              ? [
                  _c("p", { staticClass: "message" }, [_vm._v("Subsidiary")]),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.companyCode,
                          expression: "companyCode"
                        }
                      ],
                      attrs: { id: "companyCode", name: "companyCode" },
                      on: {
                        change: function($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function(o) {
                              return o.selected
                            })
                            .map(function(o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.companyCode = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        }
                      }
                    },
                    [
                      _vm.companyCode === "" || _vm.companyCode === null
                        ? _c("option", { attrs: { disabled: "", value: "" } }, [
                            _vm._v("Select")
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.companyCodeList, function(item, index) {
                        return _c(
                          "option",
                          { key: item.code, domProps: { value: item.code } },
                          [_vm._v(_vm._s(item.codeName))]
                        )
                      })
                    ],
                    2
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              { attrs: { type: "submit" }, on: { click: _vm.handleSubmit } },
              [_vm._v("Save")]
            )
          ],
          2
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a0a9f9ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a0a9f9ce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/login/RequestForAuth.vue
// module id = 1vWx
// module chunks = 0